import React from 'react';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';
import styled from 'styled-components';

import customTheme from 'app/style/theme';

import { Heading } from 'grommet';
import MenuPane from 'app/components/Menu/MenuPane';
import AnimatedEllipsis from 'app/components/AnimatedEllipsis';

// eslint-disable-next-line import/no-webpack-loader-syntax
import worker from 'worker-loader!app/api/toc.worker.js';

const tocWorker = new worker();
let TOC;

tocWorker.postMessage('get-toc');
tocWorker.onmessage = ({ data: toc }) => {
  TOC = toc;
};

const StyledEntry = styled(Heading)`
  max-width: 700px !important;
  :hover {
    cursor: pointer;
    color: ${customTheme.global.colors['neutral-2']};
    text-decoration: underline;
  }
`;

function Entry({ AppState, entry }) {
  return (
    <StyledEntry
      color={
        _.isEqual(AppState.selectedSectionItem, entry.path)
          ? 'neutral-1'
          : undefined
      }
      key={entry.path}
      responsive
      level={entry.level + 1}
      size="small"
      margin="none"
      truncate
      onClick={() => {
        AppState.toggleTOCMenu();
        AppState.changeSectionItem(entry.path);
      }}
      style={{ marginLeft: (entry.level - 1) * 15 }}
    >
      {entry.label}
    </StyledEntry>
  );
}

function TableOfContents({ AppState }) {
  if (!AppState.isTOCMenuOpen) return null;
  if (!TOC) {
    return (
      <MenuPane>
        <Heading responsive textAlign="center" margin="small" size="small">
          Table of Contents
        </Heading>
        <StyledEntry responsive level={2} size="small" margin="none">
          Loading <AnimatedEllipsis />
        </StyledEntry>
      </MenuPane>
    );
  }
  return (
    <MenuPane aria-label="table of contents">
      <Heading responsive textAlign="center" margin="small" size="small">
        Table of Contents
      </Heading>
      {TOC.entries.map((entry, index) => (
        <Entry key={'entry' + index} AppState={AppState} entry={entry} />
      ))}
      {!_.isEmpty(TOC.figures) && (
        <React.Fragment>
          <Heading responsive textAlign="center" margin="small" size="small">
            List of Figures
          </Heading>
          {TOC.figures.map((entry, index) => (
            <Entry key={'figure' + index} AppState={AppState} entry={entry} />
          ))}
        </React.Fragment>
      )}

      {!_.isEmpty(TOC.tables) && (
        <React.Fragment>
          <Heading responsive textAlign="center" margin="small" size="small">
            List of Tables
          </Heading>
          {TOC.tables.map((entry, index) => (
            <Entry key={'table' + index} AppState={AppState} entry={entry} />
          ))}
        </React.Fragment>
      )}
    </MenuPane>
  );
}

export default inject('AppState')(observer(TableOfContents));



// WEBPACK FOOTER //
// ./src/app/components/BookElements/TableOfContents.js